import { useEVChargerStore } from '../../../../hooks/useEVChargerStore';
import { ConfirmationTemplate } from '@templates';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { RoutesList } from '../../../routes/Routes';
import { basename } from '../../../routes/basename';
import { FormTitle } from '@molecules/*';
import { providers } from '../../../../constants/providerCompanies';
import { Link } from '@atoms/*';

type ProviderType = keyof typeof providers;

export const Confirmation = () => {
  const {
    resetSelective,
    data: {
      wantConfirmationEmail,
      caseReferenceId,
      provider,
      userDetails: { email },
    },
  } = useEVChargerStore();

  const location = useLocation();
  const [tempEmail, setTempEmail] = useState('');

  useEffect(() => {
    if (tempEmail === '') {
      setTempEmail(email);
    }
    // push 10 states to history to prevent user from going back to previous pages
    for (let i = 0; i < 10; i++) {
      window.history.pushState(
        { page: i },
        '',
        basename + RoutesList.CONFIRMATION,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      // Prevent default behavior and navigate to home page
      window.location.replace('https://www.westminster.gov.uk/report-it');
    };

    window.addEventListener('popstate', handlePopState);
    resetSelective();

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const providerName = providers[provider as ProviderType].provider;
  const providerEmail = providers[provider as ProviderType].email;
  const providerPhone = providers[provider as ProviderType].phone;

  const confirmationTitle = `Your report has been sent to ${providerName}`;
  const contentTitle = `What happens next?`;

  const contentSubtext = (
    <div className="text-bodyXl text-text-body mb-5 flex flex-col gap-6">
      <p>Your report has been sent to {providerName}.</p>

      {wantConfirmationEmail === 'Yes' ? (
        <>
          <p>We've sent a confirmation email to {tempEmail}</p>
          <p>We have not passed on your details.</p>
        </>
      ) : null}
      <p>We won’t contact you further about the issue.</p>
      <p>
        {providerName} will investigate and, if needed, rectify the issue you
        raised.
      </p>
    </div>
  );

  const contactTitle = `Who to contact`;
  const contactSubtext = (
    <div className="text-bodyXl text-text-body flex flex-col gap-6">
      <p>
        To get an update on this report, you should email {providerName} (
        <Link
          href={`mailto:${providerEmail}`}
          className="inline font-normal"
          linkType="inline"
          title="Email to provider company"
          external={true}
        >
          {providerEmail}
        </Link>
        ) or call on <strong>{providerPhone}</strong>. You may be asked to
        provide the CAS reference number.
      </p>
    </div>
  );

  const navigationButton = {
    label: 'Return to homepage',
    isExternalLink: true,
    href: 'https://www.westminster.gov.uk/report-it ',
  };

  const content = (
    <>
      <FormTitle text={contentTitle} subtext={contentSubtext} />
      <FormTitle text={contactTitle} subtext={contactSubtext} />
    </>
  );

  return (
    <ConfirmationTemplate
      reference={caseReferenceId}
      content={content}
      button={navigationButton}
      confirmationTitle={confirmationTitle}
      feedbackLink={true}
    />
  );
};
